import * as types from "./types";

// fetch membership data
const fetchMembershipRequest = (isFetchingByCode) => ({
   type: types.FETCH_REQUEST_START,
   payload: isFetchingByCode,
});

const fetchMembershipCompleted = (data, avilableMemberships) => ({
   type: types.FETCH_DETAILS_COMPLETED,
   payload: { data, avilableMemberships },
});

const fetchMembershipFailed = error => ({
   type: types.FETCH_DETAILS_FAILED,
   payload: error,
});


// fetch payment options data
const fetchPaymentOptionsRequest = () => ({
   type: types.FETCH_PAYMENT_OPTIONS_START,
});

const fetchPaymentOptionsCompleted = data => ({
   type: types.FETCH_PAYMENT_OPTIONS_COMPLETED,
   payload: data,
});

const fetchPaymentOptionsFailed = error => ({
   type: types.FETCH_PAYMENT_OPTIONS_FAILED,
   payload: error,
});

// payment
const paymentPurchaseRequest = (bool = true) => ({
   type: types.PAYMENT_PURCHASE_START,
   payload: bool,
});


const paymentPurchaseFailed = error => ({
   type: types.PAYMENT_PURCHASE_FAILED,
   payload: error || null,
});


const savePaymentMethodMemberCompleted = data => ({
   type: types.PAYMENT_PURCHASE_COMPLETED,
   payload: data,
});
const updatePaymentMethodMemberCompleted = data => ({
   type: types.PAYMENT_PURCHASE_UPDATE_DATA,
   payload: data,
});
const choosePurchaseCompleted = data => ({
   type: types.CHOOSE_PURCHASE_COMPLETED,
   payload: data,
});

const initPaymentDeclinedRequest = data => ({
   type: types.PAYMENT_DECLINED_START,
   payload: data,
});

const initPaymentDeclinedCompleted = data => ({
   type: types.PAYMENT_DECLINED_COMPLETED,
   payload: data,
});
const setContentAvilableMembership = data => ({
   type: types.SET_CONTENT_AVILABLE_MEMBERSHIP,
   payload: data,
});

const clearErrorStateAction = (data = null) => ({
   type: types.CLEAR_ERROR_ACTION,
   payload: data,
});
const paymentPurchaseUsingWalletRequest = (bool) => ({
   type: types.PAYMENT_PURCHASE_USING_WALLET,
   payload: bool,
});

const validatePromoCodeStart = () => ({
   type: types.VALIDATE_PROMO_CODE_START,
})
const validatePromoCodeCompleted = (code, isCodeByLink) => ({
   type: types.VALIDATE_PROMO_CODE_COMPLETED,
   payload: { code, isCodeByLink },
})
const validatePromoCodeFailed = (error) => ({
   type: types.VALIDATE_PROMO_CODE_FAILED,
   payload: error,
})

const updateCodeError = (error) => ({
   type: types.UPDATE_PROMO_CODE_ERROR,
   payload: error,
})

const clearAppliedState = () => ({
   type: types.CLEAR_APPLIED_STATE,
})
const setFreeTrialModal = (data) => ({
   type: types.SET_FREE_TRAIL_MODAL,
   payload: data,
})
const setMembershipInfoAction = (data) => ({
   type: types.SET_MEMBERSHIP_INFO,
   payload: data,
})
const pricingsByFilterStart = () => ({
   type: types.FETCH_MEMBERSHIPS_BY_FILTER_START,
});

const pricingsByFilterCompleted = (data, avilableMemberships) => ({
   type: types.FETCH_MEMBERSHIPS_BY_FILTER_COMPLETED,
   payload: { data, avilableMemberships },
});

const pricingsByFilterFailed = (error) => ({
   type: types.FETCH_MEMBERSHIPS_BY_FILTER_FAILED,
   payload: error,
});

const setBoomFiModal = (data) => ({
   type: types.SET_BOOMFI_MODAL,
   payload: data,
})

const setIsFetchingUpgrade = (bool = false) => ({
   type: types.SET_IS_FETCHING_UPGRADE,
   payload: bool,
})

export {
   fetchMembershipRequest,
   fetchMembershipCompleted,
   fetchMembershipFailed,

   fetchPaymentOptionsRequest,
   fetchPaymentOptionsCompleted,
   fetchPaymentOptionsFailed,

   paymentPurchaseRequest,
   paymentPurchaseFailed,
   savePaymentMethodMemberCompleted,

   choosePurchaseCompleted,

   initPaymentDeclinedRequest,
   initPaymentDeclinedCompleted,

   clearErrorStateAction,
   paymentPurchaseUsingWalletRequest,
   setContentAvilableMembership,

   validatePromoCodeStart,
   validatePromoCodeCompleted,
   validatePromoCodeFailed,
   updateCodeError,
   clearAppliedState,
   updatePaymentMethodMemberCompleted,
   setFreeTrialModal,

   setMembershipInfoAction,
   pricingsByFilterStart,
   pricingsByFilterCompleted,
   pricingsByFilterFailed,
   setBoomFiModal,
   setIsFetchingUpgrade,
};
